declare let require:any;
let context=require.context("./", true, /.tsx?$/);
let library:any={};
for(let key of context.keys())
{
    library[key.substring(0,key.lastIndexOf('.'))]=key;
}
delete library['./animation/react-spring/renderprops.d'];
library ['./animation/react-spring/renderprops']=require('./animation/react-spring/renderprops');;


export default function  (libraryName) {

    libraryName='./'+libraryName.substring(12);//removed /InternalShared and adding ./

    if(library[libraryName]==null) {
        console.log('Available libraries',library);
        throw 'Library not found ' + libraryName;

    }

    if(typeof library[libraryName]!='string')
        return library[libraryName];



    return context(library[libraryName]);


}